<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    @save="onSave"
    :header="header"
    :save="saveText"
    :cancel="cancelText"
    :rightCommand="true"
    :disable="disable"
  >
    <div class="sidepanel-body">
      <select-type
        :disabled="!isNewPoll"
        @input="whenSelect"
        v-model="type"
        active="active"
      />
      <div class="sidepanel-group">
        <InputText
          id="title"
          :label="$t('options.lbTitle') + ' *'"
          :placeholder="$t('options.phTitle')"
          v-model="title"
        />
        <span class="text-danger" v-if="title.length == 0">
          {{ $t('warnings.projectTitleRequired') }}
        </span>
      </div>
      <div class="sidepanel-group">
        <InputText
          :label="$t('options.lbDescription')"
          :placeholder="$t('options.phDescription')"
          v-model="description"
          :textareaCustomClass="getCustomClass"
        />
        <span class="text-size-10 pt-0 toggle-description">
          {{ getDescriptionLength }}
        </span>
      </div>

      <div class="text-size-12 mt-2">{{ $t('options.lbDeadline') }}</div>

      <div class="row justify-content-start align-items-center mx-0 deadline">
        <div
          @click="showDeadlinePicker = true"
          class="d-flex mr-1 pointer text-size-16"
        >
          {{ deadline }}
        </div>
        <BtnLink
          v-if="pollDeadline"
          @click.native="pollDeadline = null"
          class="mx-1"
          :label="$t('headline.remove')"
        />

        <BtnLink
          v-if="showDeadlinePicker"
          @click.native="showDeadlinePicker = false"
          class=""
          :label="$t('options.deadlineSetText')"
        />

        <BtnLink
          v-if="!showDeadlinePicker"
          @click.native="showCalendar"
          class=""
          :label="btnLabelAdddeadline"
        />

        <BtnLink
          v-if="showDeadlinePicker"
          @click.native="cancelCalendar"
          class=""
          :label="$t('general.cancel')"
        />
      </div>

      <div v-if="pollDeadline" class="user-time-zone text-size-14">
        <span class="text-size-12">{{ $t('general.timeZone') }}: </span>
        {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
      </div>
      <div v-if="showDeadlinePicker" class="row justify-content-center">
        <vc-date-picker
          v-model="pollDeadline"
          :attributes="attrs"
          :columns="$screens({ default: 1, lg: 2 })"
          :theme-styles="themeStyles"
          mode="dateTime"
          :is24hr="true"
          :timezone="timezone"
          is-dark
          is-inline
          :locale="locale"
        />
      </div>
      <span v-if="0"> {{ pollDeadline.toISOString() }} - {{ Date() }} </span>
      <!-- :min-date="getTodayDate"  -->

      <div v-if="isNewPoll" class="sidepanel-group">
        <input-text-validated
          :label="$t('general.userName') + ' *'"
          rules="required"
          type="text"
          vid="name"
          id="name"
          v-model="name"
          autocomplete="off"
        />
        <span class="text-danger" v-if="errors.name">
          {{ errors.name[0] }}
        </span>
      </div>

      <div v-if="!isAuthenticated">
        <div class="sidepanel-group">
          <input-text-validated
            :label="$t('polls.lbEmail')"
            rules="required"
            type="email"
            vid="email"
            id="email"
            :readonly="!isNewPoll"
            v-model="email"
            autocomplete="off"
          />
        </div>
        <span class="text-danger" v-if="errors.email">
          {{ errors.email[0] }}
        </span>
      </div>

      <!-- Automated reminder start -->
      sss
      <div class="panel-section-header text-panel-section-header mt-2  d-flex logo-manager-parent align-items-center"
      v-on:click="diplayReminderDetails = !diplayReminderDetails">
        <div class="flex-column ">
          {{ $t('automateReminder.title') }}
        <img
          class="ml-1 mr-2 flex-column border-radius premium-logo-design"
          height="50"
          srcset="/images/PremiumFavicon.png"
          alt=""
        />
        </div>
        <div class="backgroundButton flex-column">
          <font-awesome-icon  :icon="diplayReminderDetails ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']" />
        </div>
      </div>

      <template v-if="diplayReminderDetails">
        <div class="description" v-html="$t('automateReminder.description')">
        </div>
        <div class="reminder-in-days d-flex mt-2" style="max-width: 400px;">
          <div class="reminder-in-days-options1">
            <input
              type="checkbox"
              id="days_5"
              value="5"
              class="mandatory-email  mr-10"
              :disabled = "isDisableChoices"
              v-model="delayInterval"
            />
            <label
            for="days_5"
            :class="[isDisableChoices ?'disabled-text': '','font-weight-500']"
            >{{ $t('automateReminder.5Days') }}</label>
          </div>
          <div class="reminder-in-days-options2">
            <input
              type="checkbox"
              id="days_3"
              value="3"
              class="mandatory-email  mr-10"
              :disabled = "isDisableChoices"
              v-model="delayInterval"
            />
            <label
            for="days_3"
            :class="[isDisableChoices ?'disabled-text': '','font-weight-500']"
             > {{ $t('automateReminder.3Days') }} </label>
          </div>
          <div class="reminder-in-days-options3">
            <input
              type="checkbox"
              id="days_1"
              value="1"
              class="mandatory-email  mr-10"
              :disabled = "isDisableChoices"
              v-model="delayInterval"
            />
            <label for="days_1"
            :class="[isDisableChoices ?'disabled-text': '','font-weight-500']"
            >{{ $t('automateReminder.1Day') }} </label>
          </div>
        </div>

        <div class="reminder-options mt-2">
          <div class="reminder-options1">
              <input type="radio"
               class="radio-button mr-10"
               :disabled = "isDisableBeforeDealine"
               id="before_deadline_1"
               value="before_deadline"
               name="autoReminderDeadlineOption"
               v-model="delayType">
              <label
              :class="[isDisableBeforeDealine ?'disabled-text': '','font-weight-500']"
               for="before_deadline_1"
               >{{$t('automateReminder.beforeDeadline')}} ({{ deadlineForReminder }})</label>
          </div>
          <!-- :disabled = "isDisableBeforeNextDateOption" -->
          <div class="reminder-options2">
              <input type="radio"
              :disabled = "true"
              class="radio-button mr-10"
              id="before_deadline_2"
              value="before_next_date"
              name="autoReminderDeadlineOption"
              v-model="delayType">
              <label
              :class="[isDisableBeforeNextDateOption ?'disabled-text': '','font-weight-500']"
              for="before_deadline_2"
              > 
                <!-- {{$t('automateReminder.beforeNextDateOption')}} ({{ beforeNextDateForReminder }})  -->
                {{ $t('automateReminder.beforeNextDateOption') }} ({{ $t('automateReminder.notAvailable') }}) 
              </label>
          </div>
        </div>
      </template>
      <!-- Automated reminder end -->
      <!-- Subadmin start -->
      <div class="panel-section-header text-panel-section-header mt-2  d-flex logo-manager-parent align-items-center"
      v-on:click="diplayReminderDetails = !diplayReminderDetails">
        <div class="flex-column ">
          {{ $t('automateReminder.title') }}
        <img
          class="ml-1 mr-2 flex-column border-radius premium-logo-design"
          height="50"
          srcset="/images/PremiumFavicon.png"
          alt=""
        />
        </div>
        <div class="backgroundButton flex-column">
          <font-awesome-icon  :icon="diplayReminderDetails ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']" />
        </div>
      </div>

      <div class="panel-section-header text-panel-section-header mt-2 d-flex logo-manager-parent align-items-center"
      v-on:click="diplayAppearanceDetails = !diplayAppearanceDetails">
        <div class="flex-column">
          {{ $t('options.sectionAppearance') }}
        </div>
        <div class="backgroundButton flex-column">
          <font-awesome-icon  :icon="diplayAppearanceDetails ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']" />
        </div>
      </div>
      <!-- <template v-if="diplayAppearanceDetails"> </template> -->
      <template v-if="diplayAppearanceDetails">
        <div @click="selectBGImage" class="d-flex pointer">
          <div class="d-flex flex-column justify-content-center">
            <span class="text-weight-semi-bold">
              {{ $t('options.backgroundImage') }}
            </span>
            <div class="text-size-10 pt-0 toggle-description text-primary">
              {{ $t('options.backgroundImageTip') }}
            </div>
          </div>
          <img
            class="ml-auto mr-2 flex-column border-radius"
            height="50"
            :src="backgroundImageThumnail"
          />
          <div class="backgroundButton flex-column">
            <icon class="h3 text-primary mt-1" type="nextButton" />
          </div>
        </div>
        <div class="sidepanel-separator mt-2"></div>

        <!-- hide toggle if the template is custom, display when the template is default. -->
        <ToggleOption v-model="darkMode" icon="edit" class="my-2" v-if="getSelectedTemplate.isDefault == 1">
          <span class="text-weight-semi-bold">
            {{ $t('options.darkMode') }}
          </span>
          <div class="text-size-10 pt-0 toggle-description">
            {{ $t('options.darkModeTip') }}
          </div>
        </ToggleOption>
        <div class="sidepanel-separator mt-2" v-if="getSelectedTemplate.isDefault == 1"></div>
        <!-- ------ -->

        <!-- This is the label and image design for custom branding, if you want to use the dropdown uncomment the below code. -->
        <div class="d-flex pointer logo-manager-parent mt-2" @click="openCustomBranding">
          <div class="d-flex flex-column justify-content-center">
            <span class="text-weight-semi-bold">
              {{ $t('customLogo.header') }}
              <label class="col-2 col-form-label new-premium-label"> {{ $t('options.new') }} </label>
              <img
                class="ml-1 mr-2 flex-column border-radius premium-logo-design"
                height="50"
                srcset="/images/PremiumFavicon.png"
                alt=""
              />
            </span>
            <div class="text-size-10 pt-0 toggle-description">
              {{ $t('customLogo.description') }}
            </div>
          </div>
          <!-- End of label part -------- -->

          <!-- This is the drop down code for the custom branding. -->
          <!-- <template v-if="user">
              <CustomBrandingTemplates :selectLabel="'Select a design'" customClass="mb-2" :saveOnChange="true" ref="refBrandingTemplate"> </CustomBrandingTemplates>
          </template>
          <BtnLink
            @click.native="openCustomBranding"
            class="mx-1 ml-auto mr-2 flex-column border-radius font-weight-500 mt-2"
            :label="$t('customBrandingTemplate.manageDesigns')"
          /> -->

          <!-- ----- End of Drop down part--- -->
          <div class="a-self logo-image-update flex-column ">
            <img
              v-if="0"
              class="ml-auto mr-2 flex-column border-radius custom-logo-image"
              height="50"
              srcset="../../assets/logo_neu_weiss_blau_orange.png 2x"
              alt=""
            />
            <icon class="h3 text-primary mt-1" type="nextButton" />
          </div>
        </div>
      </template>
      <div class="panel-section-header text-panel-section-header mt-2">
        {{ $t('options.sectionGeneral') }}
      </div>

      <div v-if="isSuperAdmin" class="d-flex pointer logo-manager-parent mt-2" @click="openConfigureAnswer">
          <div class="d-flex flex-column justify-content-center">
            <span class="text-weight-semi-bold">
              {{ $t('configureAnswer.firstDescription') }}
              <label class="col-2 col-form-label new-premium-label"> {{ $t('options.new') }} </label>
              <img
                class="ml-1 mr-2 flex-column border-radius premium-logo-design"
                height="50"
                srcset="/images/PremiumFavicon.png"
                alt=""
              />
            </span>
            <div class="text-size-10 pt-0 toggle-description">
              {{ $t('configureAnswer.secondDescription') }}
            </div>
          </div>
          <!-- End of label part -------- -->

          <!-- ----- End of Drop down part--- -->
          <div class="a-self logo-image-update flex-column ">
            <img
              v-if="0"
              class="ml-auto mr-2 flex-column border-radius custom-logo-image"
              height="50"
              srcset="../../assets/logo_neu_weiss_blau_orange.png 2x"
              alt=""
            />
            <icon class="h3 text-primary mt-1" type="nextButton" />
          </div>
      </div>
      <div class="sidepanel-separator"></div>

      <ToggleOption
        v-if="0 || !isEvent"
        v-model="mayBeAnswers"
        :disabled="mayBeAnswerDisabled"
        icon="edit"
        class="my-2"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.mayBeAnswers') }}
        </span>

        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.mayBeAnswersTip') }}
        </div>
      </ToggleOption>
      <div v-if="0 || !isEvent" class="sidepanel-separator"></div>

      <ToggleOption
        v-if="!isEvent"
        v-model="limitedVotesPerChoice"
        icon="edit"
        :separator="false"
        class="my-2 limited-votes"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.limitedVotesPerChoice') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.limitedVotesPerChoiceTip') }}
        </div>
        <template v-slot:value>
          <InputText
            v-if="limitedVotesPerChoice"
            label=""
            v-model="votesLimit"
          />
        </template>
      </ToggleOption>

      <div v-if="!isEvent" class="sidepanel-separator"></div>

      <ToggleOption
        v-if="!isEvent"
        v-model="oneChoicePerParticipant"
        icon="edit"
        class="my-2"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.oneChoicePerParticipant') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.oneChoicePerParticipantTip') }}
        </div>
      </ToggleOption>
      <div v-if="!isEvent" class="sidepanel-separator"></div>

      <ToggleOption
        v-if="0"
        v-model="showStatisticToParticipants"
        icon="edit"
        class="my-2"
      >
        <span class="text-weight-semi-bold">
          {{ $t('options.showStatisticToParticipants') }}
        </span>
        <div class="text-size-12 pt-1">
          {{ $t('options.showStatisticToParticipantsTip') }}
        </div>
      </ToggleOption>
      <div v-if="0" class="sidepanel-separator"></div>

      <ToggleOption v-model="allowComments" icon="edit" class="my-2">
        <span class="text-weight-semi-bold">
          {{ $t('options.allowComments') }}
        </span>

        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.allowCommentsTip') }}
        </div>
      </ToggleOption>

      <div v-if="1">
        <div v-if="1" class="sidepanel-separator"></div>

        <ToggleOption v-model="allowTasks" icon="edit" class="my-2">
          <span class="text-weight-semi-bold">
            {{ $t('options.allowTasks') }}
            <label class="col-2 col-form-label new-premium-label"> New </label>
            <img
              class="ml-1 mr-2 flex-column border-radius premium-logo-design"
              height="50"
              srcset="/images/PremiumFavicon.png"
              alt=""
            />
          </span>

          <div class="text-size-10 pt-0 toggle-description">
            {{ $t('options.allowTasksTip') }}
          </div>
        </ToggleOption>
      </div>
      <div v-if="1" class="sidepanel-separator"></div>

      <ToggleOption v-if="1" v-model="hiddenPoll" icon="edit" class="mt-1">
        <span class="text-weight-semi-bold">
          {{ $t('options.hiddenPoll') }}
        </span>
        <div class="text-size-12 pt-0">
          {{ $t('options.hiddenPollTip') }}
        </div>
      </ToggleOption>

      <ToggleOption
        v-if="hiddenPoll"
        v-model="showCounts"
        icon="edit"
        class="text-size-12"
      >
        <span class="text-weight-regular">
          {{ $t('options.showCounts') }}
        </span>
      </ToggleOption>

      <div class="sidepanel-separator mt-2"></div>

      <ToggleOption v-model="notifyOnNewAnswer" icon="edit" class="my-2">
        <span class="text-weight-semi-bold">
          {{ $t('options.notifyOnNewAnswer') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.notifyOnNewAnswerTip') }}
        </div>
      </ToggleOption>

      <ToggleOption v-model="notifyOnNewUser" icon="edit" class="my-2">
        <span class="text-weight-semi-bold">
          {{ $t('options.notifyOnNewUser') }}
        </span>
        <div class="text-size-10 pt-0 toggle-description">
          {{ $t('options.notifyOnNewUserTip') }}
        </div>
      </ToggleOption>

      <hr />

      <div v-if="0" class="k-links">
        <div class="d-flex text-primary pl-3">{{ $t('options.adminLink') }}: {{ adminUrl }}</div>
        <div
          v-for="invitation in invitations"
          :key="invitation.id"
          class="d-flex text-primary pl-3"
        >
          {{ $t('options.invitationFor') }} "{{ invitation.email }}": {{ invitationUrl
          }}{{ invitation.id }}
        </div>
      </div>
      <div class="build-version text-size-10 text-size-semi-bold">
        Build number: {{ buildVersion }}
      </div>
      <div class="sidepanel-footer"></div>
    </div>
    <ModalConfirm
      v-show="showConfirm"
      :msg="$t('polls.confirmRemove')"
      :loading="false"
      @cancel="onRemoveCancel"
      @confirm="onRemoveOK"
    />

    <ModalDialog
      ref="dlgPremiumUser"
      :title="dialogContent.title"
      :labelOk="dialogContent.okLabel"
      :labelCancel="dialogContent.cancelLabel"
      :showCancelIcon="true"
      :displayCancelButton="true"
      @ok="redirectToPage()"
      :displayOkButton="true"
    >
    <!-- replace true with isPaymentComplete in displayOkButton -->
      <div class="text-small" v-html="dialogContent.description"></div>
    </ModalDialog>

  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import ToggleOption from '@/components/Edit/ToggleOption.vue';
import InputText from '@/components/UI/InputText.vue';
import SelectType from '@/components/Edit/SelectType.vue';
import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { dateMixin } from '@/components/mixins/DateMixins.js';
import { renderMixin } from '../mixins/RenderMixins';
import { constants } from '@/shared/constant';

import { mapState, mapGetters, mapActions } from 'vuex';
import Icon from '../UI/Icon.vue';

import { version } from '@/../../package';
import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import BtnLink from '../~Global/Buttons/BtnLink.vue';
import moment from 'moment';
// import CustomBrandingTemplates from './CustomBrandingTemplates.vue';
const customTemplate = require('../../shared/customTemplate');

extend('required', required);
localize('en', en);

export default {
  name: 'EditKulibri',

    props: ['backup'],
  mixins: [formValidationMixin, dateMixin, renderMixin],

  components: {
    SidePanel,
    ToggleOption,
    InputText,
    SelectType,
    Icon,
    BtnLink,
    // CustomBrandingTemplates
  },

  data() {
    const hSpacing = '15px';

    return {
      localDetails: null,
      ownerUser: null,
      showConfirm: false,
      buildVersion: version,
      disable: false,
      displayScroll: false,
      showDeadlinePicker: false,
      backupDeadline: null,
      pollDeadline: null,
      numberOfDaySelection: [],
      autoReminderDeadlineOption: '',

      themeStyles: {
        wrapper: {
          background: 'linear-gradient(to bottom right, #ff5050, #ff66b3)',
          color: '#fafafa',
          border: '0',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: '5px',
        },
        header: {
          padding: `20px ${hSpacing}`,
        },
        headerHorizontalDivider: {
          borderTop: 'solid rgba(255, 255, 255, 0.2) 1px',
          width: '80%',
        },
        weekdays: {
          color: '#6eded1', // New color
          fontWeight: '600', // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
        },
        dayContent: {
          fontSize: '0.9rem',
        },
      },
      dialogContent: {title: '', description: '', cancelLabel: '', okLabel: ''},
      diplayReminderDetails: false,
      diplayAppearanceDetails: false
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      ownerId: (state) => state.poll.poll.user.id,
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      userName: 'userName',
      isAuthenticated: 'isAuthenticated',
      currentParticipantName: 'currentParticipantName',
      isAdmin: 'isAdmin',
      isPremium: 'isPremium',
      getSelectedTemplate: 'getSelectedTemplate',
      designs: 'designs',
      isSuperAdmin: 'isSuperAdmin'
    }),

    backgroundImageThumnail() {
      return '/images/background_default_thumnail.jpg';
    },


    locale() {
      return this.$store.getters.userLocale;
    },

    timezone() {
      return '';
    },

    deadline() {
      if (!this.pollDeadline) return this.$t('options.noDeadline') + ' ';

      // let deadline = this.fullWeekDay(this.pollDeadline) + ' ';
      // deadline += this.dayMonthYear(this.pollDeadline);
      const locale = this.$i18n.locale;
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Date(this.poll.deadline).toLocaleString(locale, options);
    },
    /* get formated dealine for reminder -> radio btton -> before dealine  */
    deadlineForReminder(){
      try {
        if (!this.pollDeadline) return this.$t('automateReminder.notSet'); // date not found than reurn default message (not set)
        return moment(String(this.pollDeadline)).format(this.$t('automateReminder.dateFomatForUI')); //format date to dd.mm.yyyy and return
      } catch (error) {
        console.error(error)
        return '';
      }
    },

    /** get formated date from polls choice for rediobutton ->  before next date option*/
    beforeNextDateForReminder(){
      try {
        if(this.poll && this.poll.type && this.poll.type != 1) return this.$t("automateReminder.availableInDatePollOnly");
        if (this.pollDeadline) return this.$t('automateReminder.notAvailable'); // date not found than reurn default message (not available)
        let _days;
        if(this.poll.delay_interval){
          _days = this.poll.delay_interval;
          _days = _days.sort((a, b) => b - a);
        }
        /** if poll date found than return first date by substract days */
        if(this.poll && this.poll.choices && this.poll.choices.length > 0){
          let todayDate = moment(new Date()).format(this.$t('automateReminder.dateFomatForUI'));
          for(let i = 0; i < this.poll.choices.length; i++) {
            if(this.poll.choices[i].start) {
              for(let deadlineIndex = 0; deadlineIndex < _days.length; deadlineIndex++) {
                  let date = moment(String(this.poll.choices[i].start)).subtract(_days[deadlineIndex], 'days').format(this.$t('automateReminder.dateFomatForUI')); //substtract by largest days and format
                  if(date >= todayDate) {
                    return moment(this.poll.choices[i].start).format(this.$t('automateReminder.dateFomatForUI'));
                  }
              }
            }
          }
        }
        return this.$t('automateReminder.notAvailable');
      } catch (error) {
        console.error(error);
        return this.$t('automateReminder.notAvailable');
      }
    },


    /* enable or disable automatedReminder days ->  check boxs*/
    isDisableChoices(){
      try {
        if(!this.isPremium || !this.pollDeadline) return true;

        // let choice = null;
        // if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        //   choice = this.poll.choices
        // }
        // if(!this.pollDeadline && !choice || choice == null)  return true;

        return false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    /** disable  -> redio button -> before dealine */
    isDisableBeforeDealine(){
      if(!this.isPremium) return true;

      let choice = null;
      if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        choice = this.poll.choices
      }

      if(!this.pollDeadline && (!choice || choice == null)) return true;

      if(choice && choice.length>0 && !this.pollDeadline) return true;

      return false;

    },
    /* disable -> radio btton -> before next date option */
    isDisableBeforeNextDateOption(){
      if(!this.isPremium || (this.poll && this.poll.type && this.poll.type != 1)) return true;

      let choice = null;
      if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        choice = this.poll.choices
      }

      if((!this.pollDeadline && (!choice || choice == null)) || choice && choice.length>0 && this.pollDeadline)  {
        return true
      };

      return false;

    },

    btnLabelAdddeadline() {
      if (this.pollDeadline) {
        return this.$t('general.change');
      }
      return this.$t('general.add');
    },

    mayBeAnswerDisabled() {
      if (this.poll.options.limitedVotesPerChoice) return true;
      if (this.poll.options.oneChoicePerParticipant) return true;
      return false;
    },

    isEvent() {
      if (this.type == 2) return true;
      return false;
    },

    adminUrl() {
      let adminKey =
        this.ownerId.substring(this.ownerId.length - 4) + this.ownerId;
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        adminKey;
      return url;
    },

    invitations() {
      return this.poll.invitations;
    },

    invitationUrl() {
      let url = process.env.VUE_APP_FRONTEND_URI + '/pr/' + this.poll.id + '/';
      return url;
    },

    title: {
      get() {
        return this.poll.title;
      },
      set(value) {
        this.$store.commit('updateTitle', value);
        this.validateForm();
      },
    },

    type: {
      get() {
        return this.poll.type;
      },
      set(value) {
        this.$store.commit('updateType', value);
      },
    },

    description: {
      get() {
        return this.poll.description;
      },
      set(value) {
        this.$store.commit('updateDescription', value);
      },
    },

    name: {
      get() {
        console.log('name-->', this.ownerUser, this.user);
        if (this.ownerUser == null) {
          if (this.user) return this.user.name;
        }
        return this.ownerUser.name;
      },
      set(value) {
        this.ownerUser.name = value;
        this.$store.commit('updateName', value);
      },
    },

    email: {
      get() {
        if (this.ownerUser == null) {
          if (this.user) return this.user.email;
        }
        return this.ownerUser.email;
      },
      set(value) {
        this.ownerUser.email = value;
        this.$store.commit('updateEmail', value);
      },
    },

    mayBeAnswers: {
      get() {
        return this.poll.options.mayBeAnswers;
      },
      set(value) {
        this.$store.commit('updateMayBeAnswers', value);
      },
    },

    limitedVotesPerChoice: {
      get() {
        return this.poll.options.limitedVotesPerChoice;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
        }
        this.$store.commit('updateLimitedVotesPerChoice', value);
      },
    },

    votesLimit: {
      get() {
        return this.poll.options.votesLimit;
      },
      set(value) {
        console.log('updateVotesLimit');
        this.$store.commit('updateVotesLimit', value);
      },
    },

    darkMode: {
      get() {
        if (this.poll.options.darkMode == null) return false;
        return this.poll.options.darkMode;
      },
      set(value) {
        if(this.designs.length == 0) {
            this.loadDesign().then(() => {
              this.$store.commit('updateDarkMode', value);
              this.updateDesignTemplate(value);
            });
        } else {
          this.$store.commit('updateDarkMode', value);
          this.updateDesignTemplate(value);
        }
      },
    },

    oneChoicePerParticipant: {
      get() {
        return this.poll.options.oneChoicePerParticipant;
      },
      set(value) {
        if (value) {
          this.poll.options.mayBeAnswers = false;
        }
        this.$store.commit('updateOneChoicePerParticipant', value);
      },
    },

    showStatisticToParticipants: {
      get() {
        return this.poll.options.showStatisticToParticipants;
      },
      set(value) {
        this.$store.commit('updateShowStatisticToParticipants', value);
      },
    },

    allowComments: {
      get() {
        return this.poll.options.allowComments;
      },
      set(value) {
        this.$store.commit('updateAllowComments', value);
      },
    },

    allowTasks: {
      get() {
        return this.poll.options.allowTasks;
      },
      set(value) {
        this.$store.commit('updateAllowTasks', value);
      },
    },

    hiddenPoll: {
      get() {
        return this.poll.options.hiddenPoll;
      },
      set(value) {
        this.$store.commit('updateHiddenPoll', value);
      },
    },

    notifyOnNewAnswer: {
      get() {
        return this.poll.options.notifyOnNewAnswer;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewAnswer', value);
      },
    },

    notifyOnNewUser: {
      get() {
        return this.poll.options.notifyOnNewUser;
      },
      set(value) {
        this.$store.commit('updateNotifyOnNewUser', value);
      },
    },

    showCounts: {
      get() {
        return this.poll.options.showCounts;
      },
      set(value) {
        this.$store.commit('updateShowCounts', value);
      },
    },

    delayInterval: {
        get(){
          return this.poll.delay_interval || [];
        },
        set(value){
          this.$store.commit('updateDelayInterval', value);
        }
    },

    delayType:{
        get(){
          if(this.poll.delay_type){
            return this.poll.delay_type;
          }
          return null;
        },
        set(value){
          this.$store.commit('updateDelayType', value);
        }
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },

    isAnonymousUser() {
      if (this.poll.user.email == 'dummy@kulibri.com') {
        return true;
      }
      return false;
    },

    header() {
      if (this.isNewPoll) {
        return this.$t('create.dlgHeaderNew');
      }
      return this.$t('create.dlgHeaderEdit');
    },

    saveText() {
      // if (this.isNewPoll) {
      //   return this.$t('create.dlgSaveNew');
      // }
      // return this.$t('create.dlgSaveDone');
      if (this.poll.type == 2) {
        // if event
        if(this.isNewPoll) {
          return this.$t('create.dlgContinue');  
        }
        return this.$t('create.dlgSaveDone');
      }
      return this.$t('create.dlgSaveNew');
    },

    cancelText() {
      return this.$t('create.dlgCancel');
    },

    getCustomClass() {
      return this.displayScroll
        ? 'descriptionTextarea descriptionTextareaScroll'
        : 'descriptionTextarea';
    },

    getDescriptionLength() {
      return (
        (this.description ? this.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
  },

  watch: {
    pollDeadline: {
      deep: true,
      handler: function () {
        if(this.pollDeadline == null) {
          // when unhide the choice deadline, please remove this one
          this.delayType = null;
          this.delayInterval = null;
        } else if(this.pollDeadline && this.delayType == "before_next_date") {
          this.delayType = null;
        }
        console.log('date was updated', this.pollDeadline);
        //this.showDeadlinePicker = false;
        this.$store.commit('updateDeadline', this.pollDeadline);
      },
    },
    delayInterval: {
      deep: true,
      handler: function () {
        this.delayType = (this.pollDeadline && this.delayInterval.length > 0) ? 'before_deadline' : null;
      },
    },
    ownerUser: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
    description: {
      handler() {
        this.calculateDescriptionHeight();
      },
    },
  },

  methods: {
    ...mapActions(['updateSelectedTemplate', 'updateDesignIdInPoll', 'loadDesign']),
    onDayClick(day) {
      console.log('onDayClick:', day);
    },

    showCalendar() {
      if (this.poll.deadline) {
        this.pollDeadline = new Date(this.poll.deadline);
      } else {
        let today = new Date();
        today.setHours(23, 59, 0, 0);
        this.pollDeadline = today;
      }

      this.showDeadlinePicker = true;
      console.log('showCalendar:', this.pollDeadline);
    },

    cancelCalendar() {
      this.poll.deadline = this.backupDeadline;
      if (!this.poll.deadline) this.pollDeadline = null;
      console.log('Cancel deadline:', this.poll.deadline);
      this.showDeadlinePicker = false;
    },

    selectBGImage() {
      this.$emit('change');
    },

    openCustomBranding() {
      this.$emit('openCustomBranding');
      // if(this.user) {
      //   // put comment because, change logic to display this popup on save click in CustomBrandingTemplate file

      //   // if(!!this.user.plan == true) {
      //   //   this.$emit('openCustomBranding');
      //   // } else {
      //   //   this.dialogContent.title = this.$t('customBrandingTemplate.premiumFeature');
      //   //   this.dialogContent.description = this.$t('customBrandingTemplate.useKulibriFeatures');
      //   //   this.dialogContent.type = 'premium';
      //   //   this.dialogContent.okLabel = this.$t('customBrandingTemplate.checkMyStatus');
      //   //   this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
      //   //   this.$refs.dlgPremiumUser.openModal();
      //   // }
      // } else {
      //   this.dialogContent.title = this.$t('customBrandingTemplate.doNotHaveAccount');
      //   this.dialogContent.description = this.$t('customBrandingTemplate.notRegisteredUser');
      //   this.dialogContent.type = 'register';
      //   this.dialogContent.okLabel = this.$t('customBrandingTemplate.registerNow');
      //   this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
      //   this.$refs.dlgPremiumUser.openModal();
      // }
    },

    openConfigureAnswer() {
      this.$emit('openConfigureAnswer');
    },

    onRemoveOK() {
      this.showConfirm = false;
      this.$emit('remove');
    },

    onRemoveCancel() {
      this.showConfirm = false;
    },

    onCancel() {
      if (this.isNewPoll) {
        this.showConfirm = true;
        return;
      }
      this.$store.commit('updateDescription', this.backup.description);
      this.$store.commit('updateTitle', this.backup.title);
      this.poll.options = this.backup.options;

      let details = {
        title: this.poll.title,
        type: this.poll.type,
        description: this.poll.description,
        options: this.poll.options,
        ownerUser: this.ownerUser,
        bg_image_path: this.backgroundThumbnail,
        closed: this.poll.closed,
        deadline: this.poll.deadline,
        design_id: this.poll.design_id,
        delay_interval:this.poll.delay_interval,
        delay_type:this.poll.delay_type
      };

      console.log("calling the cancel", this.poll);

      this.$store.dispatch('updateDetails', details).then(() => {});

      this.$emit('cancel');
    },

    onSave() {
      if (
        !this.isValidEmailField() ||
        !this.isValidUserName(this.$t('general.userName'))
      )
        return;
      if (this.ownerUser && this.ownerUser.email) {
        this.ownerUser.locale = this.$i18n.locale;
      }
      console.log('editingKulibri done - ownerUser:', this.ownerUser);
      console.log("getSelectedTemplate ==> ", this.getSelectedTemplate);

      let details = {
        title: this.poll.title,
        type: this.poll.type,
        description: this.poll.description,
        options: this.poll.options,
        ownerUser: this.ownerUser,
        bg_image_path: this.backgroundThumbnail,
        closed: this.poll.closed,
        deadline: this.poll.deadline,
        design_id: this.getSelectedTemplate.id,
        delay_interval:this.poll.delay_interval,
        delay_type:this.poll.delay_type
      };

      // remove the ownerUser if you are editing an exiting poll
      // changed by Mitko to avoid updating participants (an issue if the owner is not participant)
      if (!this.isNewPoll) {
        details.ownerUser = null;
      }
      console.log('editingKulibri on save details:', details);

      const userId = this.poll.user.id;
      const newUserName = this.ownerUser.name;
      const key = this.poll.key;
      this.$store.dispatch('updateDetails', details).then((response) => {
        const poll = response.data;
        this.updateSelectedTemplate(response.data.design);
        this.updateDesignIdInPoll(response.data.design_id);
        this.$store.commit('updateOptions', poll.options);
        if (this.isNewPoll) {
          console.log('updateDetails completed:', userId, poll.user.id);
          poll.key = key; // use the old key because it is obfuscated
          // check if new user was assigned during "create new poll"
          if (userId !== poll.user.id) {
            let participant = poll.participants[0];
            participant.isCurrentUser = true;
            this.$store.commit('setPoll', poll);
            console.log('new user was asigned:', this.poll.participants);
          }

          this.$store.commit('updateName', newUserName);
        }
        this.$emit('save');
      });
    },
    whenSelect() {
      const name = this.poll.user.name;
      const email = this.poll.user.email;
      this.$store.dispatch('updateChoicesNoSort', []).then(() => {
        this.$store.commit('updateName', name);
        this.$store.commit('updateEmail', email);
        console.log(
          'User name restored after project type chnage:',
          this.poll.user
        );
      });
    },
    validateForm() {
      if (
        this.title.trim().length == 0 ||
        (this.isNewPoll == true && this.name.trim().length == 0) ||
        (this.isNewPoll == true && this.email.trim().length == 0)
      ) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    },
    calculateDescriptionHeight() {
      let descriptionTextAreaControl = document.getElementsByClassName(
        'descriptionTextarea'
      );
      if (descriptionTextAreaControl && descriptionTextAreaControl.length > 0) {
        let height = 0;
        if (descriptionTextAreaControl[0].value.length > 0) {
          height = descriptionTextAreaControl[0].offsetHeight || 0;
        }
        if (height == 0 || height == 25) {
          height =
            descriptionTextAreaControl[0].value.split('\n').length < 10
              ? 0
              : constants.textAreaMaxHeight;
        }
        this.displayScroll = height >= constants.textAreaMaxHeight;
      }
    },
    redirectToPage() {
      if(this.dialogContent.type == "register") {
        // check if the current url a project link is and if clear admin and public keys
        let redirectUrl = this.$route.path;
        if( redirectUrl ) {
          const pathArray = redirectUrl.split('/');
          redirectUrl = '/pr/' + pathArray[2];
        }

        this.$router.push({
          path: '/signin?url=' + redirectUrl,
          redirect: redirectUrl,
          props: true,
        });
      } else {
        this.$router.push('/membership');
      }
    },
    updateDesignTemplate(modeValue) {
      let darkModeString = modeValue == true ? 'dark' : 'light';
      // this.updateSelectedTemplate(response.data.design);
      for(let i = 0; i < this.designs.length; i++) {
        if(this.designs[i]['isDefault'] == true && this.designs[i]['name'].includes(darkModeString)) {
          this.updateSelectedTemplate(this.designs[i]);
          if(darkModeString == "dark") {
            customTemplate.updateDarkModeOpacity(this.designs[i].config.answerGridSection.darkModeOpacity/100);
          } else {
            customTemplate.updateLighModeOpacity(this.designs[i].config.answerGridSection.darkModeOpacity/100);
          }
          // customTemplate.renderHTML(this.designs[i]);
          break;
        }
        // if(this.designs[i]['id'] == this.poll.design_id) {
        //   this.$refs.refBrandingTemplate.updateTemplate(this.designs[i]);
        //   this.$refs.refBrandingTemplate.renderValue();
        //   break;
        // }
      }
    }
  },

  created() {
    // this.backup.title = this.poll.title;
    // this.backup.description = this.poll.description;
    this.backup.options = JSON.parse(JSON.stringify(this.poll.options));
    if (this.isAnonymousUser) {
      let ownerName = this.$t('general.userName');
      this.ownerUser = { name: ownerName, email: '' };
      this.$store.commit('updateName', ownerName);
      this.$store.commit('updateEmail', '');
    } else {
      let tempCreatorId = this.poll.user_id;
      var pos = this.poll.participants.findIndex((obj) => {
        if (obj.user) return obj.user.id == tempCreatorId;
        return false;
      });

      // this is needed becuase usr and participants are not synced after "reassignToUser" in the backend
      if (pos === -1) {
        const email = this.poll.user.email;
        this.ownerUser = { name: this.poll.user.name, email: email };
      } else {
        this.ownerUser = {
          name: this.poll.participants[pos]['name'],
          email: this.poll.participants[pos]['user']['email'],
        };
      }
    }
    console.log('new user created:', this.ownerUser);
  },
  mounted() {
    this.calculateDescriptionHeight();
    this.backupDeadline = this.poll.deadline;

    if (this.poll.deadline) {
      this.pollDeadline = new Date(this.poll.deadline);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';
// input.form-control:focus {
//   box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
//     0 0 0px rgba(126, 239, 104, 0.6);
//   outline: 0 none;
// }

.a-self {
  align-self: center;
}



.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.mr-10 {
  margin-right: 10px !important;
}
.disabled-text{
  color: gray !important;
}
.backgroundButton {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.toggle-description {
  color: $mid-grey;
}

.custom-logo-image {
  width: 40px;
  height: 40px;
  background: #1d1d1d;
  object-fit: contain;
}

.logo-manager-parent {
  cursor: pointer;
  justify-content: space-between;
  .logo-image-update {
    display: block;
  }
  // label, button {
  //   word-break: break-word;
  //   white-space: normal;
  //   width: 100px;
  //   color: $primary;
  // }
}

.reminder-in-days {
  justify-content: space-between;
}

::v-deep .limited-votes {
  .k-input-group {
    align-items: end;

    textarea {
      text-align: center;
      margin-right: 5px;
      border: 1px solid $dark-grey;
      width: 50px;
      white-space: nowrap;
      background: white;
    }
  }
}

::v-deep .descriptionTextareaScroll {
  overflow: auto !important;
}

::v-deep .vc-time-picker {
  justify-content: center !important;
}
</style>
